import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52f6afb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bgimg",
  align: "center"
}
const _hoisted_2 = { align: "center" }
const _hoisted_3 = {
  class: "sub-text text-center",
  style: {"font-weight":"400"}
}
const _hoisted_4 = { class: "typed-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blinking-cursor" }, "|", -1))
const _hoisted_6 = {
  key: 0,
  align: "center",
  style: {"margin-bottom":"90px","margin-top":"50px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_search_component = _resolveComponent("search-component")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "mt-0" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_img, {
                src: require('../../assets/main-logo.png'),
                width: "360"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.$t("landing-line")) + " ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.typeValue), 1),
              _hoisted_5,
              _createElementVNode("span", {
                class: _normalizeClass(["cursor", { typing: _ctx.typeStatus }])
              }, " ", 2)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_ctx.canSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.canSearch = true)),
            color: "#3fb984",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("get-started")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.canSearch)
          ? (_openBlock(), _createBlock(_component_search_component, {
              key: 0,
              style: {"margin-bottom":"30px"}
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_divider)
  ]))
}